"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Types_1 = require("Types");
const style = __importStar(require("./Button.styles"));
const Button = (props) => {
    switch (props.variant) {
        case Types_1.ButtonVariants.SMALL_BUTTON:
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(style.SmallButton, Object.assign({}, props),
                    props.children,
                    !props.noIcon && react_1.default.createElement(style.ChevronRight, null))));
        case Types_1.ButtonVariants.LINK_BUTTON:
            return (react_1.default.createElement(style.LinkAsButton, Object.assign({}, props),
                props.children,
                react_1.default.createElement(style.ButtonContainer, null,
                    react_1.default.createElement(style.ArrowLeft, null))));
        case Types_1.ButtonVariants.ICON_BUTTON:
            return react_1.default.createElement(style.IconButton, Object.assign({}, props), props.children);
        case Types_1.ButtonVariants.SUBMIT_BUTTON:
            return react_1.default.createElement(style.SubmitButton, Object.assign({}, props), props.children);
        case Types_1.ButtonVariants.CHEVRON_BUTTON:
            return (react_1.default.createElement(style.ChevronButtonContainer, Object.assign({}, props),
                react_1.default.createElement(style.ChevronButton, Object.assign({}, props), props.children)));
        case Types_1.ButtonVariants.ONLY_TEXT:
            return react_1.default.createElement(style.OnlyTextButton, Object.assign({}, props), props.children);
        case Types_1.ButtonVariants.SUBJECT_BUTTON:
            return react_1.default.createElement(style.SubjectButton, Object.assign({}, props), props.children);
        default:
            return react_1.default.createElement(style.StyledButton, Object.assign({}, props), props.children);
    }
};
exports.default = Button;
